import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={13}
    fill="none"
    viewBox="0 0 16 13"
    {...props}
  >
    <path
      fill="#000"
      d="M14.36 5.548c-.84 0-2.36-.307-2.833-.788-.29-.295-.36-.665-.415-.963-.068-.367-.11-.476-.267-.546-.727-.317-1.77-.499-2.86-.499-1.08 0-2.111.18-2.83.491-.156.068-.197.177-.263.543-.055.299-.123.67-.413.965-.264.269-.818.454-1.235.56a6.7 6.7 0 0 1-1.581.22c-.535 0-.897-.104-1.105-.317a1.96 1.96 0 0 1-.552-1.2c-.03-.374.04-.927.548-1.443.823-.836 1.93-1.489 3.291-1.938C5.097.219 6.521 0 7.965 0c1.453 0 2.89.221 4.153.64 1.374.455 2.492 1.114 3.322 1.959.846.86.637 2 .01 2.637-.207.21-.564.312-1.09.312M7.983 1.934c1.214 0 2.343.2 3.179.565.574.25.67.768.741 1.145.042.225.078.42.193.537.203.206 1.375.549 2.263.549.388 0 .51-.067.525-.077.25-.257.563-.89-.013-1.475C13.418 1.7 10.836.818 7.965.818c-2.848 0-5.405.872-6.842 2.332q-.349.356-.315.797c.02.247.137.503.314.685.016.01.14.08.54.08.885 0 2.047-.337 2.247-.54.113-.115.149-.31.19-.535.07-.378.163-.896.739-1.146.826-.36 1.943-.557 3.145-.557z"
    />
    <path
      fill="#000"
      d="M13.236 13H2.764c-.54 0-1.04-.216-1.404-.608a1.96 1.96 0 0 1-.52-1.46c.004-.062.095-1.555 1.023-3.06.55-.89 1.278-1.6 2.164-2.11C5.123 5.134 6.46 4.815 8 4.815s2.877.32 3.973.949a6.1 6.1 0 0 1 2.164 2.11c.928 1.505 1.02 2.998 1.023 3.06a1.96 1.96 0 0 1-.52 1.459 1.9 1.9 0 0 1-1.404.608M8 5.633c-2.51 0-4.34.89-5.437 2.646a6.4 6.4 0 0 0-.918 2.7c-.018.322.09.624.3.85.212.227.502.352.82.352h10.472c.317 0 .607-.125.82-.352a1.14 1.14 0 0 0 .3-.85c0-.013-.09-1.371-.918-2.7-1.098-1.756-2.927-2.646-5.437-2.646z"
    />
    <path
      fill="#000"
      d="M8 11.363c-1.332 0-2.416-1.102-2.416-2.456S6.668 6.45 8 6.45c1.333 0 2.417 1.102 2.417 2.456S9.333 11.363 8 11.363M8 7.27c-.888 0-1.61.734-1.61 1.637s.722 1.637 1.61 1.637 1.611-.734 1.611-1.637S8.89 7.27 8.001 7.27"
    />
  </svg>
);
export default SvgPhoneIcon;
